const PortfolioCard = ({imgSrc, title, tags, projectLink}) => {
    return (
    <div 
    className={'relative p-4 rounded-2xl bg-slate-800 hover:bg-slate-700/50 active:bg-slate-700/60 ring-1 ring-inset ring-slate-50/5 transition-colors ' }>
        <figure className="bg-slate-700 overflow-hidden aspect-square rounded-lg mb-4">
            <img 
            src={imgSrc}
            loading="lazy"
            alt={title}
            className="w-full h-full object-cover"
            />
        </figure>

        <div className="flex items-center justify-between gap-4">

            <div>
                <h3 className="text-[22px] font-normal mb-3">
                    {title}
                </h3>

                <div className="flex flex-wrap items-center gap-2">
                    {
                        tags.map((label, key) => (
                            <span 
                            key={key}
                            className="h-8 text-sm text-zinc-400 bg-zinc-50/5 
                            grid items-center px-3 rounded-lg"
                            >
                                {label}
                            </span>
                        ))
                    }
                </div>
            </div>

        </div>

        <a 
        href={projectLink}
        target="_blank"
        className="absolute inset-0"
        ></a>
    </div>
  )
}

export default PortfolioCard
